import { Helmet } from 'react-helmet';
import Customermessage9084LookupDetail
  from 'src/components/customermessage9084-lookup-detail/Customermessage9084LookupDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

import Customermessage9084ListToolbar from '../components/customermessage9084-lookup-detail/Customermessage9084ListToolbar';

const Customermessage9084Lookup = () => (
  <>
    <Helmet>
      <title>Kết quả đăng ký</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <Customermessage9084ListToolbar />
        <Box sx={{ pt: 3 }}>
          <Customermessage9084LookupDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Customermessage9084Lookup;
